export default __webpack_public_path__ + "static/media/proshop.53cc7038.png";